<template>
    <b-container>
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <div id="printme">
        <img style="width:140px;float:left;margin-top:40px;" src="@/assets/images/logo.jpg">
        <b-row>
            <b-col>
                <h5 style="margin-top:30px;" align="center"><b>Security Guards Board</b></h5>
                <P style="margin-bottom:70px;" align="center"><b>Online Registration</b></P>
                <p class="float-right"  v-if="!isApplication"><small>(This is Profile as created by You. This is not Application for Job.)</small></p>
            </b-col>
        </b-row>
        <hr>
        

        <div class="application-view">
            <div class="reg-form-box" v-if="isApplication">
                <h5 class="reg-form-title text-primary">Application Details
                </h5>
                <div class="reg-form-body">
                    <div class="row">
                        <div class='col-md-2'><strong>Job-Pool</strong></div>
                        <div class="col-md-8">
                                {{appObj.JobTitle}}    
                        </div>
                    </div>   
                    <div class="row">
                        <div class='col-md-2'><strong>Board Name</strong></div>
                        <div class="col-md-8">
                                {{appObj.BoardName}}    
                        </div>
                    </div> 
                    <div class="row">
                        <div class="col-md-6">
                            <div class='row'>
                                <div class='col-md-4'><strong>Application Number</strong></div>
                                <div class="col-md-8">
                                        {{appObj.ApplicationNo}}    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class='row'>
                                <div class='col-md-4'><strong>Application Date</strong></div>
                                <div class="col-md-8">
                                        {{appObj.ApplicationDate | formatDate}}    
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
            <hr/>
            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Personal Details
                </h5>
                <div class="reg-form-body">
                    <div class="row">
                            <div class="col-md-8">
                            <div class='row'>
                                <div class='col-md-4'>Registration Type</div>
                                 <div class="col-md-8">
                                        {{personalDetails.RegistrationTypeName}}    
                                </div>
                            </div>   
                            </div>
                    </div>    
                    <div class="row">
                        <div class="col-md-8">
                            <div class='row'>
                                <div class='col-md-4'>Profile ID :</div>
                                <div class="col-md-8">
                                    {{personalDetails.UserProfileStatus.ProfileNumber}}
                                </div>
                            </div>
                        
                            <div class='row'>
                                <div class='col-md-4'>Full Name :</div>
                                <div class="col-md-8">
                                    {{personalDetails.FirstName}} {{personalDetails.MiddleName}} {{personalDetails.LastName}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Gender :</div>
                                <div class="col-md-8" v-if="personalDetails.Gender">Male</div>
                                <div class="col-md-8" v-else>Female
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Birth Date :</div>
                                <div class="col-md-8">
                                    {{personalDetails.DOB | formatDate}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Place of Birth  :</div>
                                <div class="col-md-8">
                                    {{personalDetails.PlaceOfBirth}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Email Id</div>
                                <div class="col-md-8">
                                    {{personalDetails.EmailID}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Mobile No:</div>
                                <div class="col-md-8">
                                    {{personalDetails.MobileNo}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Landline No:</div>
                                <div class="col-md-8">
                                    {{personalDetails.LandlineNo}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>PanCard No</div>
                                <div class="col-md-8">
                                    {{personalDetails.PanCardNo}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Adhar Card No</div>
                                <div class="col-md-8">
                                    {{personalDetails.AdharNo}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Mother Name</div>
                                <div class="col-md-8">
                                    {{personalDetails.MotherName}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Married Status</div>
                                <div class="col-md-8" v-if="personalDetails.MaritalStatus">Yes</div>
                                <div class="col-md-8" v-else>No
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Nationality</div>
                                <div class="col-md-8" v-if="personalDetails.Nationality">Indian</div>
                                <div class="col-md-8" v-else>Nepali 
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Maharashtra Domiciled</div>
                                <div class="col-md-8" v-if="personalDetails.Domiciled">Yes</div>
                                <div class="col-md-8" v-else>No                                
                                 </div>
                            </div>

                            
                            <div class='row'>
                                <div class='col-md-4'>Driving</div>
                                <div class="col-md-8" v-if="personalDetails.Driving">Yes</div>
                                <div class="col-md-8" v-else>No 
                                </div>
                            </div>
                          <div class='row'>
                                <div class='col-md-4'>Mother Toungue</div>
                                <div class="col-md-8">
                                    {{personalDetails.MotherToung}} 
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            
                            <img style="width:140px" :src="getImgUrl(personalDetails.UserDocuments.PhotoPath)"><br/>
                            <img style="width:140px;height:80px;" :src="getImgUrl(personalDetails.UserDocuments.SignaturePath)">
                            <p>Specimen Signature</p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="reg-form-box" v-if="personalDetails.RegistrationType==3">
                <h5 class="reg-form-title text-primary">Deceased Guard Information
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                                <div class='col-md-4'>Deceased Registration Number</div>
                                <div class="col-md-6">
                                    {{personalDetails.DeceasedRegNum}}
                                </div>
                            
                                <div class='col-md-4'>Relation with Deceased Guard</div>
                                <div class="col-md-6" >
                                    {{personalDetails.DeceasedRelation}}
                                </div>
                                 <div class='col-md-4'>Legal Heir Name(Registration in the board )</div>
                                <div class="col-md-6">
                                    {{personalDetails.HeirFirstName}} {{personalDetails.HeirMiddleName}} {{personalDetails.HeirLastName}}
                                </div>
                                <div class='col-md-4'>Other Relation Name</div>
                                <div class="col-md-6">
                                    {{personalDetails.OtherRelationName}}
                                </div>

                                
                
                    </div>
                </div>
            </div>

            <div class="reg-form-box" v-if="personalDetails.RegistrationType==4">
                <h5 class="reg-form-title text-primary">Court Order Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                           
                                <div class='col-md-4'>Order Number</div>
                                <div class="col-md-8">
                                    {{personalDetails.OrderNum}}
                                </div>
                            
                                <div class='col-md-4'>Order Date</div>
                                <div class="col-md-8">
        
                                    {{personalDetails.OrderDate | formatDate}}
                                </div>
                            
                                <div class='col-md-4'>Court Name</div>
                                <div class="col-md-8">
        
                                    {{personalDetails.CourtName}}
                                </div>
                    </div>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Religion/ Category
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>Religion</div>
                        <div class="col-md-8">
                         {{personalDetails.UserReligionCaste.ReligionName}}
                        </div>
                    </div>

                    <div class='row'>
                        <div class='col-md-4'>Category</div>
                        <div class="col-md-8">
                            {{personalDetails.UserReligionCaste.CategoryType}}
                        </div>
                    </div>

                    <div class='row'>
                        <div class='col-md-4'>Sub-Caste</div>
                        <div class="col-md-8">
                            {{personalDetails.UserReligionCaste.SubCaste}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Employment Exchange Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>Whether registered in Employment Exchange?</div>
                        <div class="col-md-8" v-if="personalDetails.UserEmploymentExchange.EmploymentExchangeStatus">Yes
                        </div>
                        <div class="col-md-8" v-else>No
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Employment Exchange Name</div>
                        <div class="col-md-8">
                            {{personalDetails.UserEmploymentExchange.EmploymentName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Employment Exchange Registration No :</div>
                        <div class="col-md-8">
                            {{personalDetails.UserEmploymentExchange.EnoExchReg}}
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Correspondence Address Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>House No:</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.HouseNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Building No</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.BuildingNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Landmark</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.Landmark}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>State</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.StateName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>District</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.DistrictName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Taluka</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.TalukaName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Village</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.Village}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Pincode</div>
                        <div class="col-md-8">
                            {{personalDetails.CorrespondenceAddress.Pincode}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Permanent Address Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>House No:</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.HouseNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Building No</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.BuildingNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Landmark</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.Landmark}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>State</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.StateName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>District</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.DistrictName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Taluka</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.TalukaName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Village</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.Village}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Pincode</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.Pincode}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Residing Since</div>
                        <div class="col-md-8">
                            {{personalDetails.PermanentAddress.ResidingSince}}
                        </div>
                    </div>
                </div>
            </div>
             <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">User Emergency Contact
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>Contact Name:</div>
                        <div class="col-md-8">
                            {{personalDetails.UserEmergencyContact.ContactName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Address :</div>
                        <div class="col-md-8">
                            {{personalDetails.UserEmergencyContact.Address}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Mobile No :</div>
                        <div class="col-md-8">
                            {{personalDetails.UserEmergencyContact.MobileNo}}
                        </div>
                    </div>
                </div>
            </div>   

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Physical Detail
                </h5>
                <div class="reg-form-body">
                    <table class="table table-sm">
                        <tr>
                            <th>Identification Mark</th>
                            <th>Height(cm)</th>
                            <th>Weight(kg)</th>
                            <th>Chest Deflated</th>
                            <th>Chest Inflated</th>
                        </tr>
                        <tr>
                            <td>
                                {{personalDetails.UserPhysicalDetails.IndetificationMark}}
                            </td>
                            <td>
                                {{personalDetails.UserPhysicalDetails.Height}}
                            </td>
                            <td>
                                {{personalDetails.UserPhysicalDetails.Weight}}
                            </td>
                            <td>
                                {{personalDetails.UserPhysicalDetails.ChestDeflated}}
                            </td>
                            <td>
                                {{personalDetails.UserPhysicalDetails.ChestInflated}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Family Members
                </h5>
                <div class="reg-form-body">
                    <table class="table table-sm">
                        <tr>
                            <th>FullName</th>
                            <th>Gender</th>
                            <th>DOB</th>
                            <th>Relation</th>
                        </tr>
                        <tr v-for="member in personalDetails.UserFamily" :key="member">
                            <td>{{member.FullName}}</td>
                            <td v-if="member.Gender">Male</td><td v-else>Female</td>
                            <td>{{member.DOB | formatDate}}</td>
                            <td>{{member.ReletionshipName}}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Nominee Detail
                </h5>
                <div class="reg-form-body">
                    <table class="table table-sm">
                        <tr>
                            <th>FullName</th>
                            <th>Gender</th>
                            <th>DOB</th>
                            <th>Relation</th>
                            <th>Details</th>
                            <th>Guardian Name</th>
                            <th>Guardian Relation</th>
                            <th>Guardian Address</th>
                        </tr>
                        <tr v-for="member in personalDetails.UserNominee" :key="member">
                            <td>{{member.NomineeName}}</td>
                            <td v-if="member.Gender">Male</td><td v-else>Female</td>
                            <td>{{member.DOB | formatDate}}</td>
                            <td>{{member.ReletionshipName}}</td>
                            <td>{{member.RelationDetail}}</td>
                            <td>{{member.GuardianName}}</td>
                            <td>{{member.GuardianRelation}}</td>
                            <td>{{member.GuardianAddress}}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="reg-form-box empdet">
                <h5 class="reg-form-title text-primary">Employer Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>Working Status:</div>
                        <div class="col-md-8" v-if=
                            "personalDetails.UserExprienceDetails.workingStatus=1">Present</div>
                        <div class="col-md-8" v-else>Past</div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Name of Agency</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.AgencyName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Address of the Agency</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.AgencyAddress}}
                        </div>
                    </div>
                     <div class='row'>
                        <div class='col-md-4'>Agency Contact Number</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.AgencyContactNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Pasara License Number</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.PasaraLicense}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Validity Date</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.PasaraValidityDate | formatDate}}
                        </div>
                    </div>
                     <div class='row'>
                        <div class='col-md-4'>Name Of the Principal Employer</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.PrincipalEmployerName}}
                        </div>
                    </div>
                     <div class='row'>
                        <div class='col-md-4'>Principal Employer Address </div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.PrincipalEmployerAddress}}
                        </div>
                    </div>
                     <div class='row'>
                        <div class='col-md-4'>Principal Employer Contact Number</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.PrincipalContactNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Location Of Work Place</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.WorkingLocation}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Nature of Appointment</div>
                        <div class="col-md-8" v-if=
                            "personalDetails.UserExprienceDetails.AppointmentType=1">Direct Employer</div>
                        <div class="col-md-8" v-else>Through Agency</div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>PF NO</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.PFNO}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>ESIC NO</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.ESICNO}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Basic Pay</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.BasicPay}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>DA</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.DA}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Total Salary</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.TotalSalary}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Date Of Joining</div>
                        <div class="col-md-8">
                            {{personalDetails.UserExprienceDetails.StartDate | formatDate}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Last Date of Working</div>
                        <div class="col-md-8" v-if=
                            "personalDetails.UserExprienceDetails.workingStatus=1">Till Date</div>
                        <div class="col-md-8" v-else>
                            {{personalDetails.UserExprienceDetails.EndDate | formatDate}}
                        </div>
                    </div>
                </div>
            </div>


            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Qualification Details
                </h5>
                <div class="reg-form-body">
                    <table class="table table-sm">
                        <tr>
                            <th>Qualification Type</th>
                            <th>Name of Degree</th>
                            <th>State</th>
                            <th>Board / University</th>
                            <th>Class</th>
                            <th>Percentage</th>
                        </tr>
                        <tr>
                            <td>
                                {{personalDetails.UserQualification.QualificationType.QualificationTypeName}}
                            </td>
                            <td>
                                {{personalDetails.UserQualification.DegreeType.DegreeName}}
                            </td>
                            <td>
                                {{personalDetails.UserQualification.UserState.StateName}}
                            </td>
                            <td>
                                {{personalDetails.UserQualification.EducationBoard.BoardName}}
                            </td>
                            <td>
                                {{personalDetails.UserQualification.Class}}
                            </td>
                            <td>
                                {{personalDetails.UserQualification.Percentage}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Documents Uploaded
                </h5>
                <div class="reg-form-body">
                    <table class="table table-sm">
                        <tr>
                            <th>Document Type</th>
                            <th>Link</th>
                            
                        </tr>
                        <tr v-if="personalDetails.UserDocuments.PhotoPath !=''">
	                        <td>Photo</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.PhotoPath)">View</a></td>
                        </tr>
                       
                        <tr v-if="personalDetails.UserDocuments.SignaturePath !=''">
                            <td>Signature</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.SignaturePath)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.AdharCardPath !=''">
                            <td>AdharCard</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.AdharCardPath)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.RationCardPath  !=''">
                            <td>RationCard</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.RationCardPath)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.CasteCertificate !=''">
                            <td>Caste Certificate</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.CasteCertificate)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.EduCertificate  !=''">
                            <td>EduCertificate</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.EduCertificate)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.ExServiceManProof !=''">
                            <td>ExServiceManProof</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.ExServiceManProof)">View</a></td>
                        </tr>
                        <tr v-if="personalDetails.UserDocuments.ExprienceCertificate  !=''">
                            <td>Exprience Certificate</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.ExprienceCertificate)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.BirthCertificate  !=''">
                            <td>Birth Certificate</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.BirthCertificate)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.RecommendationLetter  !=''">
                            <td>Recommendation Letter</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.RecommendationLetter)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.DeceasedID  !=''">
                            <td>Deceased Guard's ID</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.DeceasedID)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.LegalHireNOC  !=''">
                            <td>Legal Hire NOC</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.LegalHireNOC)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.FinalDuesLetter  !=''">
                            <td>Final Dues Letter</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.FinalDuesLetter)">View</a></td>
                        </tr>

                        <tr v-if="personalDetails.UserDocuments.CourtOrder !=''">
                            <td>Court Order Copy</td>
                            <td><a target="_blank" :href="getImgUrl(personalDetails.UserDocuments.CourtOrder)">View</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        
        </div>
     
    </div>
    <b-row>
        <b-col>
        <!-- <b-btn @click="hideModal">Close Me</b-btn> -->
        <b-button class="float-right mt-2" variant="info" @click="print">Print Profile</b-button>
        <!-- <button v-print="'#printMe'">Print Application</button> -->
        </b-col>
     </b-row>
     </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import vueHtmlToPaper from "vue-html-to-paper";
const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
]; //Md Tofiq 28-2-19

export default {
  components: { Spinner },
  props: {
    eventid: {
      require: false,
      type: String
    }
  },
  data() {
    return {
      isApplication: false,
      isLoading: false,
      personalDetails: {
        UserID: null,
        Salutation: null,
        FullName: null,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: "",
        Age: 0,
        PlaceOfBirth: "",
        Gender: true,
        MotherName: "",
        MobileNo: "",
        MobileNo1: null,
        LandlineNo: null,
        MaritalStatus: true,
        MotherToungue: true,
        EmailID: "",
        Nationality: true,
        Domiciled: true,
        MotherToung: "",
        AdharNo: "",
        PanCardNo: "",
        CategoryType: null,
        BoardID: "",
        RegistrationType: 2,

        LoginID: "00000000-0000-0000-0000-000000000000",
        ApplicationID: null,
        TotalMarks: 0,
        ResultStatus: null,
        ExServiceMan: false,
        Driving: true,
        JobID: null,
        DeceasedRegNum: null,
        DeceasedName: null,
        DeceasedRelation: null,
        HeirFirstName:null,
        HeirMiddleName:null,
        HeirLastName:null,
        OtherRelationName: "",
        OrderNum: null,
        OrderDate: "2001-01-01T00:00:00",
        CourtName: null,
        PetitionNum: null,
        PetitionDate: "2001-01-01T00:00:00",
        UnionName: null,
        LockProfile: true,
        RegistrationTypeName:
          "Recommanded by registered Principal Employer for Registration and Allotment",
        PermanentAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "Room No.30",
          BuildingNo: "A-Wing",
          Street: "Pari Galaxy",
          Locality: "Diwa",
          Landmark: "Bander Ali",
          Village: "Diwa (West)",
          Pincode: 400612,
          Post: "Diwa",
          StateName: "Maharashtra",
          DistrictName: "Thane",
          TalukaName: "Thane"
        },

        CorrespondenceAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "Room No.30",
          BuildingNo: "A-Wing",
          Street: "Pari Galaxy",
          Locality: "Diwa",
          Landmark: "Bander Ali",
          Village: "Diwa (West)",
          Pincode: 400612,
          Post: "Diwa",
          ResidanceSince: 1,
          StateName: "Maharashtra",
          DistrictName: "Thane",
          TalukaName: "Thane"
        },
        UserPhysicalDetails: {
          UserPhysicalID: null,
          IndetificationMark: "Cut mark on forehead",
          Height: 188,
          Weight: 85,
          ChestDeflated: 100,
          ChestInflated: 105
        },
        UserQualification: {
          QualificationTypeID: "09713307-253d-4e35-aca9-50ccde3e05a6",
          DegreeID: "03c001dc-b65e-4b96-bd25-f4e425c7fab6",
          StateID: "6e394345-c136-4618-9258-d3bd530fd97b",
          BoardID: "80d06c9d-8256-4b83-ad87-620debf38d32",
          Result: 1,
          Percentage: 66.0,
          Class: "First Class",
          QualificationType: {
            QualificationTypeID: null,
            QualificationTypeName: "Graduate"
          },
          DegreeType: {
            DegreeTypeID: null,
            DegreeName: "B.A.",
            QaulificaitonTypeID: "00000000-0000-0000-0000-000000000000"
          },
          UserState: {
            StateID: "00000000-0000-0000-0000-000000000000",
            StateName: "Bihar"
          },
          EducationBoard: {
            BoardID: null,
            BoardName: "Veer Kunwar Singh University",
            InstituteType: null,
            StateID: "00000000-0000-0000-0000-000000000000"
          }
        },
        UserDocuments: {
          PhotoPath: null,
          SignaturePath: null,
          AdharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CasteCertificate: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          BirthCertificate: null,
          PoliceVerification: null,
          MedicalCertificate: null,
          RecommendationLetter: null,
          DeceasedID: null,
          LegalHireNOC: null,
          FinalDuesLetter: null,
          CourtOrder: null
        },
        UserEmergencyContact: {
          ContactName: "",
          Address: "",
          MobileNo: ""
        },
        UserExprienceDetails: {
          workingStatus: 1,
          AgencyName: "",
          AgencyAddress: "",
          WorkingLocation: "",
          AgencyContactNo: "",
          PrincipalEmployerName: "",
          PrincipalContactNo: "",
          PrincipalEmployerAddress: "",
          AppointmentType: 2,
          PFNO: null,
          ESICNO: null,
          BasicPay: 0.0,
          DA: 0.0,
          TotalSalary: 25725.0,
          StartDate: "2018-02-01T00:00:00",
          EndDate: "2001-01-01T00:00:00",
          PasaraValidityDate: "2001-01-01T00:00:00",
          PasaraLicense: null
        },
        UserReligionCaste: {
          ReligionID: "d3f6b84b-c005-474d-aff9-dd27fa763ebc",
          CategoryID: "d25679fb-92ea-434d-a0f8-65b3290c7a8b",
          ReligionName: null,
          CategoryType: null,
          SubCaste: ""
        },
        UserEmploymentExchange: {
          EmploymentName: null,
          EmploymentRegNo: null,
          EmploymentExchangeStatus: false
        },
        UserDecleration: {
          UserID: "00000000-0000-0000-0000-000000000000",
          ConfirmStatus: false,
          DeclerationText: null
        },
        ApplyForJob: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          JobId: "00000000-0000-0000-0000-000000000000",
          UserID: "00000000-0000-0000-0000-000000000000",
          Status: 0,
          PersonalDetail: false,
          AddressDetail: false,
          OtherDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          ApplicationNo: null
        },
        UserApplication: [],
        UserEvaluation: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          BatchID: "00000000-0000-0000-0000-000000000000",
          RunningMark: 0,
          PullUps: 0,
          Situps: 0,
          EducationalMarks: 0,
          Height: 0,
          Weight: 0,
          ChestDeflated: 0,
          ChestInflated: 0
        },
        UserDocumentReview: {
          Review: false,
          Comments: null,
          ApplicationID: "00000000-0000-0000-0000-000000000000"
        },
        UserDocumentUpload: {
          ApplicantPhotoStatus: false,
          ApplicantSignatureStatus: false,
          AdharCardStatus: false,
          RationCardStatus: false,
          DOBCertificateStatus: false,
          CasteCertificateStatus: false,
          DegreeCertificateStatus: false,
          ExprienceCertificateStatus: false,
          ExServiceManCertificateStatus: false
        },
        UserDocuments: {
          PhotoPath: "",
          SignaturePath: "",
          AdharCardPath: "",
          PancardPath: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: ""
        },
        UserNominee: [
          {
            NomineeID: "2ff23306-0f82-4613-8197-1aff4533d8b",
            NomineeName: "",
            Gender: false,
            DOB: "",
            ReletionShip: 3,
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          }
        ],
        UserProfileStatus: {
          PersonalDetail: false,
          AddressDetail: false,
          PhysicalDetail: false,
          NomineeDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          FamilyDetail: false
        },
        UserFamily: [
          {
            FamilyID: "efc2815c-68ef-4211-b804-2dde92d97522",
            FullName: "",
            Gender: false,
            DOB: "",
            ReletionShipID: "6fce0f55-2fb6-45b3-ad1f-aa6eb9cecae7",
            ReletionshipName: "",
            UserID: ""
          }
        ]
      },
      docObj: {},
      docTbl: [],
      appObj: {}
    };
  },
  methods: {
    //   Md Tofiq (B) 28-2-19
    // convertDateFormat(inDate) {
    //   //return indate.split("T")[0];
    //   let dbDateTime = new Date(inDate);
    //   let formattedDate =
    //     dbDateTime.getDate() +
    //     "-" +
    //     months[dbDateTime.getMonth()] +
    //     "-" +
    //     dbDateTime.getFullYear();
    //   return formattedDate;
    // },
    // Md (E)
    print() {
      this.$htmlToPaper("printme");
    },

    getImgUrl(pic) {
      let userinfo = this.$store.getters.loggedUser;
      let userId = userinfo.UserId;
      if (pic) {
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" + userId + "/" + pic
        );
      }
    }
  },

  mounted() {
      this.isLoading = true;
    if (this.eventid) {
      this.appObj = this.$store.getters.getAppObj;
      //   this.appObj.ApplicationDate = this.convertDateFormat(
      //         this.appObj.ApplicationDate
      //       );
      this.isApplication = true;
    }

    var userinfo = this.$store.getters.loggedUser;
    let promiseU = apis.ReadUserDetail2(userinfo.UserId); //Personal Details

    promiseU
      .then(response => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body;
          //   this.personalDetails.DOB = this.convertDateFormat(response.body.DOB);
          //   //   Md Tofiq (B) 28-2-19
          //   this.personalDetails.OrderDate = this.convertDateFormat(
          //     response.body.OrderDate
          //   );
          //   this.personalDetails.PetitionDate = this.convertDateFormat(
          //     response.body.PetitionDate
          //   );
          //   this.personalDetails.UserExprienceDetails.PasaraValidityDate = this.convertDateFormat(
          //     response.body.UserExprienceDetails.PasaraValidityDate
          //   );
          //   this.personalDetails.UserExprienceDetails.StartDate = this.convertDateFormat(
          //     response.body.UserExprienceDetails.StartDate
          //   );
          //   this.personalDetails.UserExprienceDetails.EndDate = this.convertDateFormat(
          //     response.body.UserExprienceDetails.EndDate
          //   );
          // MD (E)
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
          this.isLoading = false;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
        this.isLoading = false;
      });
  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewProfile.vue